import { httpInstance } from '@/services/httpInstance';

const updateBannerService = async (dataParam) => {
  let res;
  const endpoint = '/frontlabels/v1/promos';
  const dataSent = dataParam;

  await httpInstance.put(
    endpoint,
    dataSent,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default updateBannerService;
